
const useConfiguration = (key = null) => {
  const configuration = window.site_configuration
  return key ? configuration[key] : configuration
}

export default useConfiguration